import { createApp } from 'vue'
import App from '@/components/App.vue'

import router from '@/router'
import store from '@/store'
import dialog, { DialogInterface } from 'eop-shared-components/plugins/dialog'
import vTooltip from 'eop-shared-components/plugins/v-tooltip'
import vLink from 'eop-shared-components/plugins/v-link'
import preference from 'eop-shared-components/plugins/preference'
import naver from 'vue3-naver-maps'
import report from 'eop-shared-components/plugins/report'

import api from '@/api'

import Icon from 'eop-ui-controls/commons/Icon.vue'
import { CLIENT_KEY } from '@/constants'
import ENV, { NAVER_MAP_CLIENT_ID, REPORT_SERVER_URL } from '@/constants/env'

const app = createApp(App)

app.use(router)
app.use(store)
app.use(dialog, { store })
app.use(preference, { store, prefix: 'portal' })
app.use(vTooltip, { store })
app.use(vLink, { router })
app.use(naver, { clientId: NAVER_MAP_CLIENT_ID, subModules: 'geocoder' })
app.use(report, {
  store,
  serverEnv: ENV,
  serverUrl: REPORT_SERVER_URL,
  getUserAccount: () => store.getters['accounts/getUserAccount'],
  clientKey: CLIENT_KEY,
})

app.config.unwrapInjectedRef = true

app.config.globalProperties.$api = api

app.component('Icon', Icon)

window.addEventListener('resize', () => store.dispatch('system/updateWindowSize'))

app.mount('body')

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $api: typeof api
    $dialog: DialogInterface
  }
}
